import { Component, OnInit, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RouteHelperService } from '../../services/route-helper.service';
import { SummaryPeFormInstanceApiModel } from '@app/api/api-models/pe-features/SummaryPeFormInstanceApiModel';

@Component({
  templateUrl: './reject-pe-summaries-modal.component.html',
  styleUrls: ['./reject-pe-summaries-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RejectPeSummariesModalComponent implements OnInit {
  @Input()
  public mode: 'delete' | 'reject' | 'submit';

  @Input()
  public confirm: Function;

  @Input()
  public reject: Function;

  @Input()
  public isClickable: boolean;

  @Input()
  public summaryFormInstances: Array<SummaryPeFormInstanceApiModel>;

  @HostBinding('class')
  public modalType = 'lg';

  public actionButtonText: string;
  public actionProcess: string;
  public actionText: string;
  public explanation = 'This form is used as a data source in the following forms:';

  constructor(private readonly bsModalRef: BsModalRef, private readonly routeHelper: RouteHelperService) {
    this.isClickable = true;
  }

  public ngOnInit(): void {
    if (this.mode === 'reject') {
      this.actionButtonText = 'Yes, Reject';
      this.actionProcess = 'rejecting';
      this.actionText = 'reject';
    }

    if (this.mode === 'delete') {
      this.actionButtonText = 'Yes, Delete';
      this.actionProcess = 'deleting';
      this.actionText = 'delete';
    }

    if (this.mode === 'submit') {
      this.actionButtonText = 'Yes, Submit';
      this.actionProcess = 'submitting';
      this.actionText = 'submit';
      this.explanation = 'This form will be used as a data source in the following forms:';
    }
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public cancel(): void {
    this.reject();
    this.close();
  }

  public openFormInstance(id: number): void {
    if (!this.isClickable) {
      return;
    }

    this.routeHelper.formInstance(id).then(() => this.routeHelper.reload(this.routeHelper.getCurrentUrl()));

    this.close();
  }

  public onConfirm(): void {
    this.confirm();

    this.close();
  }
}
